import MappingTabs from "../functions/fintTechmappingtabs.js";
import { useEffect, useState } from "react";
import { Tabs } from "antd";
import MultiselectComponent from "../components/MultiselectComponent";
import DropDownMenu from "../components/DropDownMenu";
import { useSelector, useDispatch } from "react-redux";
import InputField from "../components/InputField";
import {
  getOutputColumnsData,
  getInputColumnsData,
  saveAsMappings,
  getEditStateData,
  getChangesFlag,
  setunSavedRulesChanges,
} from "../store/workspaceSlice";
import Button from "../components/Button";
import CheckBox from "../components/CheckBox";
import { showAddedRulesToast } from "../helpers.js";
const initialruleObject = {
  appliedRule: 1,
  grpBy: false,
  conditionalColumn: "",
  grpByCol: [],
  dateColumn: "",
  dateColumnType: "",
  aggregateColumn: "",
  grpByColMappings: {},
  outputTargetCol: [],
  customGrouping: {},
  grpByOperation: "",
  output: [],
  positiveNegativeSeparately: false,
  groupValuesByKey: false,
  descriptionColumn: "", // used for Lazada for extra description
  activeTab: "1",
  currency: [], // e.g. ["USD", "SGD"]
  useExtraField: false,
  weeklyDateTypeToInsert: "",
};
const initialMappings = {
  key: "",
  account: "",
  description: "",
  secondary: { account: "", description: "" },
};
// Tabs
const items = [
  {
    key: "1",
    label: "Custom Grouping",
  },
  {
    key: "2",
    label: "Key And Additional Description",
  },
];

const GroupbyFeaturePage = () => {
  const [mapObject, setMappingsData] = useState(initialruleObject);
  const [selectgroubycols, setselectgroubycols] = useState();
  const [selectOutputCols, setselectOutputCols] = useState();
  const outputColsData = useSelector(getOutputColumnsData);
  const inputColsData = useSelector(getInputColumnsData);

  // For creating Custom grouping aka Graphs
  const [keyInput, setKeyInput] = useState("");
  const [valueInput, setValueInput] = useState("");

  const [extraFieldInput, setExtraFieldInput] = useState("");
  const [useExtraField, setUseExtraField] = useState(false);
  const [customGrouping, setCustomGrouping] = useState({});
  const dispatch = useDispatch();
  const [mappings, setMappings] = useState([initialMappings]);
  const [activeTab, setActiveTab] = useState("1");
  const state = useSelector(getEditStateData);
  const [isInLocalEditMode, setIsInLocalEditMode] = useState(false);
  const USfalg = useSelector(getChangesFlag); // unsaved changes flag

  // Edit information
  useEffect(() => {
    if (state?.type === "grpby") {
      const { customGrouping, grpByCol, outputTargetCol, ...rest } = state.data;
      setselectgroubycols(
        grpByCol.map((item) => ({
          label: item,
          value: item,
        }))
      );
      setselectOutputCols(
        outputTargetCol.map((item) => ({
          label: item,
          value: item,
        }))
      );
      setUseExtraField(state.data?.useExtraField || false);
      setCustomGrouping({ ...customGrouping });

      setMappings(
        state.data?.finTech
          ? Object.values(state.data.finTech).map((item) => ({
              ...item,
              secondary: { ...item.secondary },
            }))
          : [initialMappings]
      );

      setMappingsData((prev) => ({
        ...prev,
        ...rest,
        outputTargetCol,
        grpByCol,
        customGrouping: { ...customGrouping }, // custom grouping
      }));
      setIsInLocalEditMode(true);
    }
  }, [state?.data, state?.type, state?.data?._id]);

  const addKeyValue = () => {
    if (!keyInput || !valueInput) return;

    setCustomGrouping((prev) => ({
      ...prev,
      [keyInput]: useExtraField
        ? {
            values: [...(prev[keyInput]?.values || []), valueInput],
            additionalField: extraFieldInput,
          }
        : [...(prev[keyInput] || []), valueInput], // Old behavior if extraField is not needed
    }));

    setKeyInput("");
    setValueInput("");
  };

  const deleteKey = (key) => {
    const updatedData = { ...customGrouping };
    delete updatedData[key];
    setCustomGrouping(updatedData);
  };

  const handlesetselectgroubycols = (selectedOptions) => {
    setselectgroubycols(selectedOptions);
    setMappingsData({
      ...mapObject,
      grpByCol: selectedOptions.map((sel) => sel.value).sort(), // Sort before saving,
    });
  };

  const handlesetselectOutputCols = (selectedOptions) => {
    setselectOutputCols(selectedOptions);
    setMappingsData({
      ...mapObject,
      outputTargetCol: selectedOptions.map((sel) => sel.value),
    });
  };

  const handleOnChange = (e, type) => {
    if (type === "selectedInputColum") {
      let ifFound = inputColsData.find(
        (chr) => chr.inColChr === e.target.value
      );
      if (ifFound) {
        setMappingsData((prevData) => ({
          ...prevData,
          [e.target.name]:
            e.target.type === "checkbox" ? e.target.checked : e.target.value,
          inColDT: ifFound.inColDT,
          ...ifFound,
        }));
      }
    } else {
      setMappingsData((prevData) => ({
        ...prevData,
        [e.target.name]:
          e.target.type === "checkbox" ? e.target.checked : e.target.value,
      }));
    }
    if (!USfalg) {
      dispatch(setunSavedRulesChanges(true));
    }
  };
  const handleAddNewRule = () => {
    // Cleaning mappings data
    const cleanedMappings = Object.fromEntries(
      Object.entries(mapObject?.grpByColMappings).filter(([key]) =>
        mapObject?.outputTargetCol.includes(key)
      )
    );
    const updatedMapObject = {
      ...mapObject,
      grpByColMappings: cleanedMappings,
    };
    // console.log(`Updated Map Object`, updatedMapObject);

    dispatch(
      saveAsMappings({
        ...updatedMapObject,
        customGrouping: customGrouping,
        useExtraField, // used for Lazada for extra description
        finTech: {
          ...mappings,
        },
      })
    );
    showAddedRulesToast(
      mapObject.appliedRule,
      isInLocalEditMode ? "Updated" : "added"
    ); // Show toast notification
    reset();
  };
  const reset = () => {
    setMappingsData(initialruleObject);
    setCustomGrouping({});
    setselectOutputCols("");
    setselectgroubycols("");
    setMappings([]);
    setIsInLocalEditMode(false);
  };

  return (
    <div className="w-full pb-4 ">
      <div className="w-full grid grid-cols-1 sm:grid-cols-2 gap-4 m-2 p-2">
        <DropDownMenu
          label="Select Date Column"
          name="dateColumn"
          value={mapObject.dateColumn}
          options={inputColsData.map((item) => ({
            label: item.inColChr,
            value: item.inColChr,
          }))}
          onChange={(e) => handleOnChange(e)}
        />
        <DropDownMenu
          label="Select Conditioning Column"
          name="conditionalColumn"
          value={mapObject.conditionalColumn}
          options={inputColsData.map((item) => ({
            label: item.inColChr,
            value: item.inColChr,
          }))}
          onChange={(e) => handleOnChange(e)}
        />
        <DropDownMenu
          label="Select Date Column Type"
          name="dateColumnType"
          value={mapObject.dateColumnType}
          options={[
            {
              label: "Week",
              value: "week",
            },
            {
              label: "single day",
              value: "singleDay",
            },
          ]}
          onChange={(e) => handleOnChange(e)}
        />
        <DropDownMenu
          label="Define Aggregation Column"
          name="aggregateColumn"
          value={mapObject.aggregateColumn}
          options={inputColsData.map((item) => ({
            label: item.inColChr,
            value: item.inColChr,
          }))}
          onChange={(e) => handleOnChange(e)}
        />
        <MultiselectComponent
          options={inputColsData.map((item) => ({
            label: item.inColChr,
            value: item.inColChr,
          }))}
          selectedOptions={selectgroubycols}
          handleSetSelect={handlesetselectgroubycols} // Handle the selection change
          label={"Select GroupBy Columns"}
        />
        <MultiselectComponent
          options={outputColsData.map((item) => ({
            label: item.outColChr,
            value: item.outColChr,
          }))}
          selectedOptions={selectOutputCols}
          handleSetSelect={handlesetselectOutputCols} // Handle the selection change
          label={"Select Output Column(s)"}
        />{" "}
        {mapObject?.dateColumnType === "week" && (
          <DropDownMenu
            label="Weekly Date Type to Insert"
            name="weeklyDateTypeToInsert"
            value={mapObject.weeklyDateTypeToInsert}
            options={[
              {
                label: "Date Range (From-To)",
                value: "dateRange",
              },
              {
                label: "Start Date",
                value: "startDate",
              },
              {
                label: "End Date",
                value: "endDate",
              },
            ]}
            onChange={(e) => handleOnChange(e)}
          />
        )}
        <div className="col-span-2 flex  gap-2">
          <CheckBox
            name={"positiveNegativeSeparately"}
            chkBoxText={"Aggregate Positive, Negative separately"}
            checked={mapObject.positiveNegativeSeparately}
            onChange={handleOnChange}
          />
          <CheckBox
            name={"groupValuesByKey"}
            chkBoxText={"Group values by key"}
            checked={mapObject.groupValuesByKey}
            onChange={handleOnChange}
          />
        </div>
        {useExtraField && (
          <InputField
            name="descriptionColumn"
            label={"Define Extra Field Column"}
            type="text"
            placeholder="Enter Description Column"
            value={mapObject.descriptionColumn}
            onChange={(e) => {
              const upperCaseValue = e.target.value.toUpperCase().trim();

              handleOnChange({
                target: { name: e.target.name, value: upperCaseValue },
              });
            }}
          />
        )}
        {mapObject.grpByCol.length === 1 &&
          mapObject.outputTargetCol.length > 0 && (
            <div className="col-span-2 flex justify-start items-end gap-x-8">
              <div className="min-h-10 flex">
                <CheckBox
                  name={"sameAsOutput"}
                  chkBoxText={"Same as output GroupBy Column"}
                  onChange={(e) => {
                    if (e.target.checked) {
                      setMappingsData((prevState) => ({
                        ...prevState,
                        grpByColMappings: Object.fromEntries(
                          Object.values(prevState.outputTargetCol).map(
                            (key) => [key, mapObject.grpByCol[0]] // 0 because will work if only one output column is selected
                          )
                        ),
                      }));
                    }
                  }}
                />
              </div>
            </div>
          )}
      </div>
      {mapObject.grpByCol.length > 0 &&
        mapObject.outputTargetCol.length > 0 && (
          <div className="w-full p-2 mx-2">
            <label className="font-semibold">
              Map group-by columns to output column
            </label>
            {/* <div className="flex flex-wrap gap-4">
              {mapObject.outputTargetCol.map((column, index) => {
                if (!(column in mapObject.grpByColMappings)) {
                  setMappingsData((prevState) => ({
                    ...prevState,
                    grpByColMappings: {
                      ...prevState.grpByColMappings,
                      [column]: "", // Set default value if not present
                    },
                  }));
                }

                return (
                  <InputField
                    label={column}
                    key={column}
                    value={mapObject.grpByColMappings[column] || ""}
                    type="text"
                    placeholder="Maps to ..."
                    onChange={(e) => {
                      const rawValue = e.target.value.toUpperCase().trim();

                      if (rawValue === "") {
                        setMappingsData((prevState) => ({
                          ...prevState,
                          grpByColMappings: {
                            ...prevState.grpByColMappings,
                            [column]: "", // Clear the field
                          },
                        }));
                        return;
                      }

                      if (
                        mapObject.grpByCol.includes(rawValue) ||
                        mapObject.conditionalColumn == rawValue ||
                        mapObject.dateColumn == rawValue ||
                        mapObject.aggregateColumn == rawValue ||
                        mapObject.descriptionColumn == rawValue
                      ) {
                        setMappingsData((prevState) => ({
                          ...prevState,
                          grpByColMappings: {
                            ...prevState.grpByColMappings,
                            [column]: rawValue,
                          },
                        }));
                      } else {
                        message.destroy(); // Clear any existing message first
                        message.error(
                          `Invalid input: "${rawValue}" is not included in group by columns.`
                        );
                      }
                    }}
                  />
                );
              })}
            </div> */}
            <div className="grid grid-cols-1 xl:grid-cols-2 gap-4 mt-2">
              {mapObject.outputTargetCol.map((column) => (
                <DropDownMenu
                  key={column}
                  label={column}
                  name={column}
                  required={true}
                  value={mapObject.grpByColMappings[column] || ""}
                  options={[
                    ...(mapObject?.grpByCol?.map((col) => ({
                      label: col,
                      value: col,
                    })) || []),

                    {
                      label: mapObject?.conditionalColumn,
                      value: mapObject?.conditionalColumn,
                    },
                    {
                      label: mapObject?.dateColumn,
                      value: mapObject?.dateColumn,
                    },
                    {
                      label: mapObject?.aggregateColumn,
                      value: mapObject?.aggregateColumn,
                    },
                    {
                      label: mapObject?.descriptionColumn,
                      value: mapObject?.descriptionColumn,
                    },
                  ]
                    // remove null/undefined/empty
                    .filter((opt) => opt?.value)
                    // remove duplicates by value
                    .filter(
                      (opt, index, self) =>
                        index === self.findIndex((o) => o.value === opt.value)
                    )}
                  onChange={(e) => {
                    // Update the grpByColMappings state
                    setMappingsData((prevState) => ({
                      ...prevState,
                      grpByColMappings: {
                        ...prevState.grpByColMappings,
                        [column]: e.target.value || "",
                      },
                    }));
                  }}
                />
              ))}
            </div>
          </div>
        )}
      <div className="w-full px-4 mx-2">
        <Tabs
          size="large"
          defaultActiveKey="1"
          items={items}
          onChange={(key) => (
            setActiveTab(key), setMappingsData({ ...mapObject, activeTab: key })
          )}
        />
      </div>
      {activeTab === "1" && (
        <>
          <h1 className="px-4"> Define Custom Grouping</h1>
          <div className="mx-auto px-4 py-2 bg-white">
            <div className="w-full grid grid-cols-5 gap-4 items-end">
              <div className="col-span-2">
                <InputField
                  name="key"
                  type="text"
                  placeholder="Enter Key"
                  value={keyInput}
                  onChange={(e) => setKeyInput(e.target.value)}
                />
              </div>
              <div className="col-span-2">
                <InputField
                  name="value"
                  type="text"
                  placeholder="Enter Value"
                  value={valueInput}
                  onChange={(e) => setValueInput(e.target.value)}
                />
              </div>
              <div className="col-span-1 flex items-center gap-2">
                <input
                  type="checkbox"
                  checked={useExtraField}
                  onChange={() => setUseExtraField(!useExtraField)}
                />
                <label>Extra Field?</label>
              </div>

              {useExtraField && (
                <div className="col-span-4">
                  <InputField
                    name="extraField"
                    type="text"
                    placeholder="Enter Additional Field"
                    value={extraFieldInput}
                    onChange={(e) => setExtraFieldInput(e.target.value)}
                  />
                </div>
              )}

              <div className="col-span-1">
                <Button
                  btnText={"Add"}
                  handleOnClick={addKeyValue}
                  className="bg-blue-500 text-white p-2 rounded w-full"
                  disabled={!keyInput || !valueInput} // Disable if inputs are empty
                >
                  Add
                </Button>
              </div>
            </div>

            <div className="mt-4 bg-gray-100 rounded h-52 overflow-auto">
              {Object.keys(customGrouping).map((key) => {
                const entry = customGrouping[key];

                return (
                  <div
                    key={key}
                    className="flex items-center justify-between px-2 py-1 border rounded "
                  >
                    <div>
                      <strong>{key}:</strong>
                      {Array.isArray(entry) ? (
                        <span> [ {entry.join(", ")} ] </span>
                      ) : (
                        <span>
                          [ {entry.values.join(", ")} ]
                          {entry.additionalField && (
                            <span className="text-sm text-gray-600">
                              {" "}
                              (Extra: {entry.additionalField})
                            </span>
                          )}
                        </span>
                      )}
                    </div>
                    <button
                      onClick={() => deleteKey(key)}
                      className="bg-red-500 text-white p-1 rounded"
                    >
                      Delete
                    </button>
                  </div>
                );
              })}
            </div>
          </div>
        </>
      )}
      {activeTab === "2" && (
        <div className="p-4">
          {
            <MappingTabs
              mappings={mappings}
              setMappings={setMappings}
              inputColsData={inputColsData}
              mapObject={mapObject}
              setMappingsData={setMappingsData}
            />
          }
        </div>
      )}

      <div className="mt-4 col-span-2 flex gap-2 px-2">
        <Button
          btnText={`${isInLocalEditMode ? "Update" : "Save"}`}
          handleOnClick={handleAddNewRule}
          disabled={!(mapObject.grpByCol.length > 0)}
        />
        <Button btnType="cancel" btnText={"Reset"} handleOnClick={reset} />
      </div>
    </div>
  );
};

export default GroupbyFeaturePage;
